var path = 'app/denied/denied.html';
var html = "<section id=\"login\" class=\"section-cont\">\n<div class=\"col-md-6 col-md-offset-3\">\n  <h2>Sorry, you need to be authorized for that.</h2>\n</div>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/denied/denied.html
// module id = ./app/denied/denied.html
// module chunks = 0